import PersonalAccount from "./pages/PersonalAccount";
import Slider from "./Components/Sliders";
import BusinessAccount from "./pages/BusinessAccount";
import BusinessOpenAccount from "./pages/BusinessOpenAccount";
import CompanyOpenAccount from "./pages/CompanyOpenAccount";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  HashRouter,
} from "react-router-dom";
import OpenAccount from "./pages/OpenAccount";
import NewBusinessOpenAccount from "./pages/NewBusinessOpenAccount";
import NewCompanyOpenAccount from "./pages/NewCompanyOpenAccount";
import NewBusinessAccount from "./pages/NewBusinessAccount";
import ReferenceConsent from "./pages/ReferenceConsent";
import { Helmet } from "react-helmet";
import FloatingChatBtn from "./Components/FloatingChatBtn/FloatingChatBtn";
import UpgradeAccount from "./pages/UpgradeAccount";
import { useDetectSlowInternet } from "./customHooks/useDetectSlowInternet";
import useReturnToHome from "./customHooks/useReturnToHome";

function App() {
  useDetectSlowInternet();
  useReturnToHome();
  return (
    <div>
      <HashRouter>
        <Routes>
          <Route path="/personal-account" element={<PersonalAccount />} />
          <Route path="/business-account" element={<BusinessAccount />} />
          <Route
            path="/open-business-account"
            element={<BusinessOpenAccount />}
          />
          <Route path="/open-account" element={<OpenAccount />} />
          <Route path="/" element={<Slider />} />
          <Route path="/personal-account" element={<PersonalAccount />} />
          <Route path="/ex-personal-account" element={<PersonalAccount />} />
          <Route path="/open-account" element={<OpenAccount />} />
          <Route
            path="/reference-consent/:token"
            element={<ReferenceConsent />}
          />

          <Route
            path="/open-company-account"
            element={<CompanyOpenAccount />}
          />
          <Route
            path="/new-company-account"
            element={<NewCompanyOpenAccount />}
          />
          <Route
            path="/new-business-account"
            element={<NewBusinessOpenAccount />}
          />
          <Route
            path="/open-business-account"
            element={<BusinessOpenAccount />}
          />
          <Route path="/open-business-info" element={<NewBusinessAccount />} />
          <Route path="/upgrade-account" element={<UpgradeAccount />} />
        </Routes>
      </HashRouter>
      <FloatingChatBtn />
      <div
        id="log-output"
        className="position-fixed top-0 start-0 text-danger"
      ></div>
    </div>
  );
}

export default App;
